module.exports = __webpack_public_path__ + "static/media/logo-full.11a5030f.svg";